import { projectRequest } from 'store/utils/request';
import { CANCEL_ANNOTATE_ID } from './actions';

/* eslint-disable import/prefer-default-export */
export const annotateRequest = async data => {
  const THREE_MINUTES_IN_MILLISEC = 3 * 60 * 1000;

  try {
    return await projectRequest.post(`/annotate/`, data, {
      timeout: THREE_MINUTES_IN_MILLISEC,
      requestId: CANCEL_ANNOTATE_ID,
    });
  } catch (error) {
    throw error;
  }
};
